import React from "react";
import Media from "@qlik/qlik/src/components/Media";

/**
 * FooterCommunity component
 * This component renders the social links in the footer.
 * Each link is rendered with a Media component.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {Array} props.socialLinks - The array of social links to be rendered.
 * Each link object should have an id, url, icon, and title.
 * @param {String} props.title - The title of the footer section.
 * @param {String} props.className - The CSS class to apply to the footer section.
 *
 * @returns {React.Element} The rendered FooterCommunity component.
 */
const FooterCommunity = ({ socialLinks, title, className }) => (
    <div className={className}>
        <ul className="flex gap-3.75 flex-wrap max-lg:w-full">
            {socialLinks?.map((socialLink) => {
                // Skip rendering if the social link does not have a URL
                if (!socialLink.externalUrl) return null;
                return (
                    <li
                        key={socialLink?.id}
                        className="flex items-center max-lg:justify-between  max-lg:w-full lg:gap-7.5"
                    >
                        <a
                            href={socialLink?.externalUrl}
                            target="_blank"
                            rel="noreferrer"
                            className="text-blue text-sm font-semibold leading-tight xl:hover:text-green"
                        >
                            {socialLink?.icon?.[0]?.secure_url && socialLink?.title ? (
                                <Media
                                    className="w-5 h-5 hover:filter-green transition-all duration-200"
                                    link={socialLink?.icon?.[0]?.secure_url}
                                    alt={socialLink?.title}
                                />
                            ) : (
                                socialLink?.title
                            )}
                        </a>
                        {socialLink?.subItems && (
                            <ul className="flex gap-3.75 flex-wrap">
                                {socialLink?.subItems?.map((socialLink) => {
                                    return (
                                        <li key={socialLink?.id}>
                                            <a href={socialLink?.externalUrl} target="_blank" rel="noreferrer">
                                                {socialLink?.icon?.[0]?.secure_url && socialLink?.title ? (
                                                    <Media
                                                        className="w-5 h-5 hover:filter-green transition-all duration-200"
                                                        link={socialLink?.icon?.[0]?.secure_url}
                                                        alt={socialLink?.title}
                                                    />
                                                ) : (
                                                    socialLink?.title
                                                )}
                                            </a>
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                    </li>
                );
            })}
        </ul>
    </div>
);

export default FooterCommunity;
